import { useMutation, useQueryClient } from "react-query";

import { thirdParty } from "../utils";

export interface IUseUpdateProductMutationParameters {
    checkoutId: string;
    lineItemId: string;
    quantity: number;
}

export const useUpdateProduct = (invalidQueryKeys: string[] = []) => {
    const queryClient = useQueryClient();

    const {
        mutateAsync,
        mutate,
        isIdle,
        isLoading,
        data,
        error,
        isError,
        isSuccess,
    } = useMutation({
        mutationFn: async (parameters: IUseUpdateProductMutationParameters) => {
            const { checkoutId, lineItemId, quantity } = parameters;
            return await thirdParty.shopify.updateProduct(
                checkoutId,
                lineItemId,
                quantity,
            );
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });

    return {
        mutate,
        mutateAsync,
        isLoading,
        data,
        error,
        isIdle,
        isError,
        isSuccess,
    };
};
